<template>
  <div id="app" :class="{ 'pc-app': isPcView }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import { isPcClient } from '@/views/PC/utils';

export default {
  name: 'App',
  data() {
    return {
      isPcView: isPcClient(),
    };
  },
  watch: {
    isPcView(val) {
      document.body.classList.toggle('pc-mode', val);
    },
  },
  mounted() {
    document.body.classList.toggle('pc-mode', this.isPcView);
    if (this.isPcView) {
      this._onResize = () => {
        this.isPcView = isPcClient();
      };
      window.addEventListener('resize', this._onResize);
    }
  },
  beforeDestroy() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
    }
  },
};
</script>
